import { NavLink, useNavigate } from 'react-router-dom';
import { removeTokens } from '../../utils/auth.utils';
import './topbar.css';
import api from '../../services/api';

const TopBar: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const fetchUserLogout = async () => {
      try {
        await api.delete('auth/users/logout');
      } catch (error) {
        console.error('Error executing user logout:', error);
      }
    };
    await fetchUserLogout();
    removeTokens();
    navigate('/');
  };
  return (
    <header className="topbar text-white p-4 text-center w-100 d-flex justify-content-between">
      {/* Desplegable alineado a la derecha */}
      <div className="dropdown ms-auto">
        <button
          className="btn dropdown-toggle custom-dropdown-btn h4-font-size"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="bi bi-person-fill"></i>
          Mi Cuenta
        </button>
        <ul className="dropdown-menu">
          <li>
            <NavLink className={() => 'dropdown-item'} to="/profile">
              Editar perfil
            </NavLink>
          </li>
          <li>
            <NavLink
              className={() => 'dropdown-item'}
              to="#"
              onClick={async (e) => await handleLogout(e)}
            >
              Cerrar sesión
            </NavLink>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default TopBar;
